module.exports = __webpack_public_path__ + "img/banner-products.006a6f65.jpg";